"use client";

import { c as _c } from "react/compiler-runtime";
import { getReplay } from "@sentry/nextjs";
import { useEffect } from "react";
import { useAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
export function SentryArticlePageViewRecording() {
  const $ = _c(4);
  const consent = useCookiebotConsent();
  const {
    user: t0
  } = useAuthentication();
  const {
    isLoggedIn
  } = t0;
  let t1;
  let t2;
  if ($[0] !== consent.submitted || $[1] !== isLoggedIn) {
    t1 = () => {
      const replay = getReplay();
      const shouldRecord = isLoggedIn && consent.submitted;
      const isRecording = replay?.getRecordingMode() !== undefined;
      if (shouldRecord && !isRecording) {
        replay?.start();
      } else {
        if (!shouldRecord && isRecording) {
          replay?.stop();
        }
      }
    };
    t2 = [isLoggedIn, consent.submitted];
    $[0] = consent.submitted;
    $[1] = isLoggedIn;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}